import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

const seoLinks = [
  { slug: 'guida-completa-itaobuy-spreadsheet', label: 'Guida Completa Itaobuy Sheet' },
  { slug: 'come-utilizzare-itaobuy-sheet', label: 'Come Utilizzare Itaobuy Sheet' },
  { slug: 'migliori-scarpe-sneakers-2026', label: 'Migliori Sneakers 2026' },
  { slug: 'guida-hoodies-felpe-moda', label: 'Guida Hoodies e Felpe' },
  { slug: 'shopping-internazionale-guida', label: 'Shopping Internazionale' },
  { slug: 'errori-shopping-evitare', label: 'Errori da Evitare' },
  { slug: 'borse-tendenze-2026', label: 'Borse di Tendenza' },
  { slug: 'profumi-guida-acquisto', label: 'Guida Profumi' },
];

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-14">
          <div>
            <h4 className="text-foreground-950 font-heading text-base font-semibold mb-6">
              Categorie Prodotto
            </h4>
            <div className="w-8 h-px bg-background-200 mb-5"></div>
            <div className="grid grid-cols-2 gap-x-4 gap-y-3">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.displayName}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-950 font-heading text-base font-semibold mb-6">
              Risorse SEO
            </h4>
            <div className="w-8 h-px bg-background-200 mb-5"></div>
            <div className="flex flex-col gap-3">
              {seoLinks.map((link) => (
                <Link
                  key={link.slug}
                  to={`/articoli/${link.slug}`}
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                Home Page
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-950 font-heading text-base font-semibold mb-6">
              Legale
            </h4>
            <div className="w-8 h-px bg-background-200 mb-5"></div>
            <div className="flex flex-col gap-3">
              <a
                href="/privacy"
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                Privacy Policy
              </a>
              <a
                href="/cookie"
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                Cookie Policy
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-950 font-heading text-base font-semibold mb-6">
              Contatti
            </h4>
            <div className="w-8 h-px bg-background-200 mb-5"></div>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                Chi Siamo
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
              >
                Politica Editoriale
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <Link to="/" className="text-foreground-950 font-heading text-3xl font-bold tracking-tight leading-none cursor-pointer">
              Itaobuy<span className="text-primary-500">.</span>
            </Link>
            <p className="text-xs text-foreground-500 mt-2 max-w-xs">
              La piattaforma italiana di riferimento per la ricerca prodotti con fogli di calcolo organizzati.
            </p>
          </div>

          <div className="flex flex-col sm:items-end gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 itaobuyspread.work. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className="ri-pinterest-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}